import React, { useEffect, useState } from 'react'
import useStyles from './styles'

interface CountdownBarProps {
    currentProgress: number
    timeLeft: number
}

const CountdownBar: React.FC<CountdownBarProps> = ({ currentProgress, timeLeft }) => {
    const classes = useStyles()

    const [animation, setAnimation] = useState(false)

    useEffect(() => {
        setAnimation(true)
    }, [])

    return (
        <div className={classes.progressBar}>
            <div
                className={classes.bar}
                style={{
                    transform: `scaleX(${animation ? 1 : currentProgress})`,
                    transition: `transform ${timeLeft / 1000}s linear`,
                }}
            ></div>
        </div>
    )
}

export default React.memo(CountdownBar)
